// extracted by mini-css-extract-plugin
export default {"content":"CtaBanner_content__t9SBL","heading":"CtaBanner_heading__nYOMZ","container":"CtaBanner_container__1atR9","banner":"CtaBanner_banner__YikT6","link":"CtaBanner_link__myGk2"};